// eslint-disable-next-line import/prefer-default-export, no-shadow
  export enum BuyNowActionTypes {
    POST_BUY_NOW = 'POST_BUY_NOW',
  }
  